import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoHeaderFn = /* @__PURE__ */ createRecipe('logo-header', {}, [])

const logoHeaderVariantMap = {}

const logoHeaderVariantKeys = Object.keys(logoHeaderVariantMap)

export const logoHeader = /* @__PURE__ */ Object.assign(memo(logoHeaderFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoHeader',
  __getCompoundVariantCss__: logoHeaderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoHeaderVariantKeys,
  variantMap: logoHeaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoHeaderVariantKeys)
  },
  getVariantProps: logoHeaderFn.getVariantProps,
})